export class Strings {
    static readonly HealthConnectUnavailable = "Health Connect isn't available on this device.";
    static readonly HealthConnectPermissionsNotGranted = "Health Connect permissions aren't granted. Please grant them first.";
}